export default (function($) {
  'use strict';

  $(document).ready(function() {
    $('.js-menu-trigger').bind('click', function() {
      if ($(this).attr('aria-expanded') === 'false') {
        $('.js-nav-main-mobile').removeClass('h-0');
        $(this).attr('aria-expanded', 'true');
      } else {
        $('.js-nav-main-mobile').addClass('h-0');
        $(this).attr('aria-expanded', 'false');
      }
    });

    $('.js-submenu-trigger').bind('click', function() {
      if ($(this).attr('aria-expanded') === 'false') {
        $(this)
          .parents('.js-menu-item')
          .children('.js-submenu')
          .removeClass('h-0');
        $(this).attr('aria-expanded', 'true');
      } else {
        $(this)
          .parents('.js-menu-item')
          .children('.js-submenu')
          .addClass('h-0');
        $(this).attr('aria-expanded', 'false');
      }
    });
  });
})(jQuery);



// WEBPACK FOOTER //
// ./resources/js/mobile-nav.js